import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const dynamicPageConfigSlice = createSlice({
  name: 'DynamicPageConfig',
  initialState: null as any,
  reducers: {
    setPageConfig: (state, action: PayloadAction<any>) => {
      return action.payload;
    },
  },
});

export const { setPageConfig } = dynamicPageConfigSlice.actions;
export default dynamicPageConfigSlice.reducer;